import { baseUrl } from '@/config/config'
var axios = require("axios").default;
const localData = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
const token = localData.token
export default class Master {
    async MedicalDirector() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/medical_director`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async AsstManager() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/ast_manager_distribution`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async Manager() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/manager`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async HCRPManager() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/hcrp_manager`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async AllupdateSystem(data) {
        try {
            const response = await axios.post(`${baseUrl}users//update_other_users`, data, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }

    };
}